<div>
  <div *ngIf="!hideBack" class="backButton mb-4">
    <h3 class="text-l font-weight-bolder" *ngIf="community != undefined" [routerLink]="[ '/',community.code , 'tickets']"
      queryParamsHandling="merge"><fa-icon [icon]="faArrowLeft"></fa-icon> {{ 'GoToList' | translate }}</h3>
  </div>
  <div *ngIf="$loading()">
    <div>
      <p-skeleton styleClass="w-100" width="10rem" height="20rem"></p-skeleton>
    </div>
    <div class="row mt-3">
      <div class="col-12 col-md-8">
        <p-skeleton styleClass="w-100" width="10rem"></p-skeleton>
        <p-skeleton styleClass="w-75 mt-3" width="10rem"></p-skeleton>
        <p-skeleton styleClass="w-75 mt-2" width="10rem"></p-skeleton>
        <p-skeleton styleClass="w-100 mt-3"></p-skeleton>
        <p-skeleton styleClass="w-100 mt-1"></p-skeleton>
        <p-skeleton styleClass="w-100 mt-1"></p-skeleton>
        <p-skeleton styleClass="w-100 mt-1"></p-skeleton>
        <p-skeleton styleClass="w-100 mt-1"></p-skeleton>
      </div>
      <div class="col-12 col-md-4">
        <p-skeleton styleClass="w-100" height="5rem"></p-skeleton>
        <p-skeleton styleClass="w-25 mt-2"></p-skeleton>
        <p-skeleton styleClass="w-50 mt-1"></p-skeleton>
      </div>
    </div>
  </div>
  <div *ngIf="!$loading()" class="detail-wrapper">

    <div class="image-box">
        @if (model().images && model().images.length > 0) {
            <swiper-container
                    class="swiper-events"
                    slides-per-view="1"
                    loop="true"
                    autoplay="false"
                    pagination="false"
                    navigation="true"
                    allow-touch-move="true"
                    space-between="5">

                @for (imgSrc of model().images; track imgSrc) {
                    <swiper-slide >
                        <img       data-fancybox="gallery" [src]="imgSrc | imageUrl">
                    </swiper-slide>
                }

            </swiper-container>
        } @else {
            <div class="default-image-container">
                <img [src]="defaultImg | imageUrl">
            </div>
        }
      <div *ngIf="(!model().endEvent || sameDay) && model().startEvent" class="event-date one-date">
        <div class="date-number">
          <span>{{ model().startEvent | date: 'd' }}</span>
          <span>{{ model().startEvent | localizedDate: 'MMMM' }}</span>
        </div>
      </div>
      <div *ngIf="model().endEvent && !sameDay && model().startEvent" class="event-date two-dates">
        <div class="date-number">
          <span>{{ model().startEvent | date: 'd' }}</span>
          <span>{{ model().startEvent | localizedDate: 'MMMM' }}</span>
        </div>
        <span>
          <i class="fa-solid fa-right-long arrow-icon"></i>
        </span>
        <div class="date-number">
          <span>{{ model().endEvent | date: 'd' }}</span>
          <span>{{ model().endEvent | localizedDate: 'MMMM' }}</span>
        </div>
      </div>
    </div>
    <div class="white-row p-4">
      <div class="row">
        <div class="col-12 col-md-8">
          <div>
            <span class="category">{{ model().categoryName }}</span>
            <h1 class="ml-0 pl-0 title">{{model().name}}</h1>
          </div>
          <div class="row">
              <div class="col-12 date-info " *ngIf="model().startEvent">

                  <!-- ⭐ SOLO STARTEVENT -->
                  <ng-container *ngIf="!model().endEvent">
                    <span>
                      <i class="fa fa-calendar info-icon"></i>
                        {{ model().startEvent | localizedDate: "EEEE, dd MMMM yyyy HH:mm" }} h
                    </span>
                  </ng-container>

                  <!-- ⭐ START + END → MISMO DÍA -->
                  <ng-container *ngIf="model().endEvent && sameDay">
                      <div>
                          <div>
                              <i class="fa fa-calendar info-icon"></i>
                              {{ model().startEvent | localizedDate: "EEEE, dd MMMM yyyy" }}
                          </div>
                          <div *ngIf="!model().allDay">
                              <i class="fa fa-clock-o info-icon"></i>
                              {{ model().startEvent | localizedDate: "HH:mm" }} h -
                              {{ model().endEvent | localizedDate: "HH:mm" }} h
                          </div>
                      </div>
                  </ng-container>

                  <!-- ⭐ START + END → DÍAS DIFERENTES -->
                  <ng-container *ngIf="model().endEvent && !sameDay">
                      <div class="date-info">
                          <div>
                              <i class="fa fa-calendar info-icon"></i>
                          </div>

                          <div>
                                <span>
                                  {{ 'From' | translate }}
                                    {{ model().startEvent | localizedDate: "EEEE, dd MMMM yyyy HH:mm" }} h
                                </span>
                              <br>
                              <span>
                              {{ 'To' | translate }}
                              {{ model().endEvent | localizedDate: "EEEE, dd MMMM yyyy HH:mm" }} h
                            </span>
                          </div>
                      </div>
                  </ng-container>

              </div>

              <div class="col-12" *ngIf="model().locationString">
              <span class="date-info">
                <i class="fa fa-map-marker info-icon"></i>
                {{ model().locationString }}
              </span>
            </div>
            <div class="col-12">
              <hr>
            </div>
            <div class="col-12">
              <div class="new-inner-body ml-0 pl-0" [innerHTML]="model().description | safe: 'html'"></div>
              <div *ngIf="model().files.length">
                <b class="mb-2">{{'Fitxers_adjunts' | translate}}</b>
                <div class="col-12 mb-3 mt-1">
                  <app-file-uploader category="events" [viewOnly]=" true" [maxFiles]="5" [type]="1"
                    [(files)]="model().files"></app-file-uploader>
                </div>
              </div>
            </div>
            <div class="col-12" *ngIf="model().locationLat && model().locationLng">
              <h3 class="text-lg">
                <strong>{{ 'Location' | translate }}:</strong>
              </h3>
              <span>
                <i class="fa fa-map-marker info-icon"></i>
                {{ model().locationString }}
              </span>
              <app-mapbox class="map mt-3" [centerlat]="model().locationLat" [centerlng]="model().locationLng"
                [lat]="model().locationLat" [lng]="model().locationLng" [scrollWheelZoom]="true">
              </app-mapbox>
              <button class="how-to-arrive mt-3" (click)="openMaps()">
                <i class="fa fa-map me-1"></i>
                <span>{{ 'HowToArrive' | translate }} </span>
              </button>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-4">
          <div class="sticky-content">
              <div *ngIf="openStatus == OpenStatuses.FUTURE">
                  <div class="dot bg-gray" ></div>
                  <b class=" ms-3 text-gray">{{ 'TICKETING.Period_future' | translate }}</b>
              </div>
              <div *ngIf="openStatus == OpenStatuses.OPEN">
                  <div class="dot bg-success" ></div>
                  <b class=" ms-3 text-success">{{ 'TICKETING.Period_open' | translate }}</b>
              </div>
              <div *ngIf="openStatus == OpenStatuses.PAST">
                  <div class="dot bg-danger" ></div>
                  <b class=" ms-3 text-danger">{{ 'TICKETING.Period_past' | translate }}</b>
              </div>
          </div>
            <div class="mt-1 mb-3" [class.text-success]="openStatus == OpenStatuses.OPEN"
                 [class.text-danger]="openStatus == OpenStatuses.PAST"
                 [class.text-gray]="openStatus == OpenStatuses.FUTURE">
                    <span>
                      {{ dateOpen | datestring : dateClose : true}}
                    </span>
            </div>
            @if (model().ticketId && !isMobile) {
              @if (openStatus == OpenStatuses.OPEN && (!isFull || waitingListUserDetails)) {
                <button class="buy-btn" [class.disabled-btn]="!buyButtonState.enabled"
                  [disabled]="!buyButtonState.enabled" (click)="openTicketModal()">
                  <strong>
                    <i *ngIf="buyButtonState.enabled" class="fa fa-ticket me-1"></i>
                    {{buyButtonState.text}}
                  </strong>
                </button>
                @if (waitingListUserDetails) {
                  <button class="buy-btn bg-white border border-danger text-danger mt-3 rounded fw-bold" (click)="confirmRejectWaitingList()">
                    {{ 'INSCRIPTIONS.Skipturn' | translate }}
                  </button>
                }
              }
              @if (openStatus == OpenStatuses.OPEN && isFull && !waitingListUserDetails && !accessCode) {
                <button class="buy-btn disabled-btn" disabled>
                  {{ exceededKey() | translate }}
                </button>
              }
              @if (openStatus == OpenStatuses.OPEN && isFull && ticket()?.waitingList && !waitingListUserDetails && !accessCode) {
                <button class="buy-btn outline mt-2 rounded fw-bold" (click)="openWaitingListForm()">
                  {{ 'INSCRIPTIONS.JoinWaitingList' | translate }}
                </button>
              }
              @if (openStatus == OpenStatuses.FUTURE || openStatus == OpenStatuses.PAST) {
                <button class="buy-btn disabled-btn" [disabled]="true">
                  {{ buyButtonState.text }}
                </button>
              }
            }
            <div *ngIf="!isCustom && addToCalendarLoaded && canAddCalendar" class="mt-3">
              <a #addCalendar (click)="addToCalendar()" class="calendar-btn-icon">
                <i class="pi pi-calendar-plus"></i>
                <span class="pe-2">{{ 'AddToCalendar' | translate }}</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    @if (model().ticketId && isMobile) {
      <div class="mobile-cta-bar">
        @if (openStatus == OpenStatuses.OPEN && (!isFull || waitingListUserDetails)) {
          <button type="button" class="buy-btn" [class.disabled-btn]="!buyButtonState.enabled"
            [disabled]="!buyButtonState.enabled" (click)="openTicketModal()">
            <strong>
              @if (buyButtonState.enabled) {
                <i class="fa fa-ticket me-1" aria-hidden="true"></i>
              }
              {{ buyButtonState.text }}
            </strong>
          </button>
          @if (waitingListUserDetails) {
            <button type="button" class="buy-btn bg-white border border-danger text-danger rounded fw-bold" (click)="confirmRejectWaitingList()">
              {{ 'INSCRIPTIONS.Skipturn' | translate }}
            </button>
          }
        } @else if (openStatus == OpenStatuses.OPEN && isFull && !waitingListUserDetails && !accessCode) {
          @if (ticket()?.waitingList) {
            <p class="mobile-cta-status mb-0">{{ exceededKey() | translate }}</p>
            <button type="button" class="buy-btn rounded fw-bold" (click)="openWaitingListForm()">
              <i class="fa fa-list-ul me-1" aria-hidden="true"></i>
              {{ 'INSCRIPTIONS.JoinWaitingList' | translate }}
            </button>
          } @else {
            <button type="button" class="buy-btn disabled-btn" disabled>
              {{ exceededKey() | translate }}
            </button>
          }
        } @else if (openStatus == OpenStatuses.FUTURE || openStatus == OpenStatuses.PAST) {
          <button type="button" class="buy-btn disabled-btn" [disabled]="true">
            {{ buyButtonState.text }}
          </button>
        }
      </div>
    }
  </div>
